import { useCallback } from 'react';
import { pick } from 'ramda';
import { useDispatch } from 'react-redux';

import { storageService } from 'js/services/storage.service';
import { isProceedLoginInNative } from 'js/app/hooks/auth/helpers';
import { useAppSelector } from '@core/js/store/hooks/useAppSelector';
import { userSetAttributesAction, userUnsetAttributesAction } from 'js/hooks/user/store/actions';
import { useGetSubscriptionActionTypes } from '@core/js/hooks/auth/hooks/useGetSubscriptionActionTypes';
import { useHandleActions } from 'js/components/system/App/hooks/usePushNotifier/hooks/useHandleActions';

import * as server from '@core/js/hooks/auth/server';

// core, added userParams.authType(line 22) and isProceedLoginInNative(line 26)
export const useSuccessLoginAction = () => {
    const dispatch = useDispatch();
    const startWindowSession = useStartWindowSession();
    const handleActions = useHandleActions();

    return useCallback(async (userParams) => {
        const windowSessionId = Math.floor(Math.random() * 100000000);

        if (userParams.authType === 'credentials') {
            storageService.local.setItem('sessionStartBrowserTime', new Date().getTime());
        }

        if (!isProceedLoginInNative()) {
            dispatch(userUnsetAttributesAction('password'));
        }

        dispatch(userSetAttributesAction({
            role: 'user',
            isLoggedIn: true,
            hasBeenLoggedIn: true,
            sessionStartBrowserTime: storageService.local.getItem('sessionStartBrowserTime'),
            windowSessionId,
            ...userParams
        }));

        const response = await startWindowSession(windowSessionId);
        const { actions = [] } = response.data;

        await handleActions(actions, { windowSessionId });

    }, [dispatch, handleActions, startWindowSession]);
};

/* core */
export const useStartWindowSession = () => {
    const subscriptionActionTypes = useGetSubscriptionActionTypes();
    const {
        sessionSubscriptionTags = '',
        sessionSubscriptionBalances = '',
        // 123 -- AgeVerificationStatus
        sessionSubscriptionRequestedPlayerData = '123'
    } = useAppSelector(pick([
        'sessionSubscriptionTags',
        'sessionSubscriptionBalances',
        'sessionSubscriptionRequestedPlayerData'
    ]));

    return useCallback((windowSessionId) => {
        const subscriptionTags = sessionSubscriptionTags
            .split(',')
            .map(tag => tag.trim())
            .concat(['uam/hidden/playerRecentGames']);
        const subscriptionBalanceTypes = sessionSubscriptionBalances
            .split(',')
            .map(type => type.trim());
        const subscriptionRequestedPlayerData = sessionSubscriptionRequestedPlayerData
            .split(',')
            .map(type => type.trim());

        return server.startWindowSession({
            windowSessionId,
            subscriptionTags,
            subscriptionActionTypes,
            subscriptionBalanceTypes,
            subscriptionRequestedPlayerData
        });
    }, [sessionSubscriptionTags, subscriptionActionTypes, sessionSubscriptionBalances, sessionSubscriptionRequestedPlayerData]);
};
